/* eslint-disable no-dupe-keys */
import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Divider,
  Typography,
} from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import GppGoodIcon from "@mui/icons-material/GppGood";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import { Link, useLocation } from "react-router-dom";
import { NAV } from "../Navbar/navbarTheme";
import { FONT_FAMILY } from "../../theme";
import { sectionTitleSpacingSx } from "../sectionHeaderStyles";
import { getCategoryProductsPath } from "../utils/shopApi";

import ContactChat from "../Hellper/ContactChat";
import heroSlide01 from "../Images/HomePage/1- Drinks.jpg";
import heroSlide02 from "../Images/HomePage/2- baby care.jpg";
import heroSlide03 from "../Images/HomePage/3- Confectionery & Sweets.jpg";
import heroSlide04 from "../Images/HomePage/4- Biscuits, Cakes & Bars.jpg";
import heroSlide05 from "../Images/HomePage/5- Crisps, Nuts & Snacks.jpg";
import heroSlide06 from "../Images/HomePage/6- Grocery.jpg";
import heroSlide07 from "../Images/HomePage/7- Frozen.jpg";
import heroSlide08 from "../Images/HomePage/8- Personal Care & Wellbeing.jpg";
import heroSlide09 from "../Images/HomePage/9- Household & Cleaning.jpg";
import heroSlide10 from "../Images/HomePage/10- Pet Care.jpg";
import heroSlide11 from "../Images/HomePage/11- Free From & Special Diet.jpg";
import heroSlide12 from "../Images/HomePage/12 - Seasonal Ranges for Every Occasion.jpg";
import aboutWarehouseImg from "../Images/HomePage/Untitled design.png";
import ferreroLogo from "../Images/Brands/ferrero-logo-png_seeklogo-289458.png";
import kinderLogo from "../Images/Brands/kinder-vector-logo.png";
import lindtLogo from "../Images/Brands/Lindt-Logo.png";
import marsLogo from "../Images/Brands/Mars-Logo.png";
import nestleLogo from "../Images/Brands/Nestle-Logo.png";
import cocaColaLogo from "../Images/Brands/Coca-Cola-logo.png";
import hariboLogo from "../Images/Brands/Haribo-logo.png";
import kelloggsLogo from "../Images/Brands/Kelloggs-Logo.png";
import kitKatLogo from "../Images/Brands/Kit-Kat-Logo.png";
import mondelezLogo from "../Images/Brands/Mondelez-Logo.png";
import pepsicoLogo from "../Images/Brands/PepsiCo-Logo-1.png";
import redBullLogo from "../Images/Brands/Red-Bull-logo.png";
import starbucksLogo from "../Images/Brands/Starbucks-logo.png";
import unileverLogo from "../Images/Brands/Unilever-Logo.png";
import weetabixLogo from "../Images/Brands/weetabix-logo.png";
import evianLogo from "../Images/Brands/Evian-logo.png";
import monsterLogo from "../Images/Brands/Monster-Energy-logo-2.png";
import swizzelsLogo from "../Images/Brands/Swizzels-Logo-High-Resolution.png";
import perfettiLogo from "../Images/Brands/perfetti-van-melle-logo-png-transparent.png";
import agBarrLogo from "../Images/Brands/ag-barr-logo-png_seeklogo-450750.png";
import supplierDrinks from "../Images/Supplier/1 - Drinks.jpg";
import supplierBabyCare from "../Images/Supplier/2 - Baby care.jpg";
import supplierConfectionery from "../Images/Supplier/3 - Confectionery & Sweets.jpg";
import supplierBiscuits from "../Images/Supplier/4 - Biscuits, Cakes & Bars.jpg";
import supplierCrisps from "../Images/Supplier/5 - Crisps, Nuts & Snacks.jpg";
import supplierGrocery from "../Images/Supplier/6 - Grocery.jpg";
import supplierFrozen from "../Images/Supplier/7 - Frozen.jpg";
import supplierPersonalCare from "../Images/Supplier/8 - Personal Care & Wellbeing.jpg";
import supplierHousehold from "../Images/Supplier/9 - Household & Cleaning.jpg";
import supplierPetCare from "../Images/Supplier/10 - Pet Care.jpg";
import supplierFreeFrom from "../Images/Supplier/11 - Free From & Special Diet.jpg";
import supplierSeasonal from "../Images/Supplier/12- Seasonal Ranges for Every Occasion.jpg";
import howItWorksBrowseImg from "../Images/How it works/Browse Products.png";
import howItWorksBasketImg from "../Images/How it works/Add to Basket.png";
import howItWorksInquiryImg from "../Images/How it works/Submit Inquiry.png";
import howItWorksDispatchImg from "../Images/How it works/Confirmation & Dispatch.png";
import specificProductImg from "../Images/How it works/specific .png";
import serviceConsolidationImg from "../Images/Our Services/Consolidation & Bulk Loading.png";
import serviceTransportImg from "../Images/Our Services/Flexible Transportation Solutions.png";
import serviceLabellingImg from "../Images/Our Services/Labelling & Packaging Services.png";
import serviceExportDocsImg from "../Images/Our Services/Export Documentation & Compliance.png";
import serviceEndToEndImg from "../Images/Our Services/End to End Support.png";

const TRUSTED_BRANDS_BG = "#305486";
const HOME_PAGE_MAX_WIDTH = 1480;
const PROMOTIONS_API_URL = "https://uktomars.co.uk/api/promotions";
const PROMOTIONS_STORAGE_BASE = "https://api.uktomars.co.uk/storage/";
const HOME_PROMOTIONS_LIMIT = 3;
const PROMOTION_IMAGE_ASPECT_RATIO = "1200 / 1800";

const toPromotionAssetUrl = (value = "") => {
  if (!value) return "";
  if (value.startsWith("http")) return value;
  return `${PROMOTIONS_STORAGE_BASE}${value.replace(/^\/+/, "")}`;
};

const supplierCategories = [
  { src: supplierDrinks, alt: "Drinks", title: "Drinks", slug: "drinks" },
  {
    src: supplierBabyCare,
    alt: "Baby care",
    title: "Baby care",
    slug: "baby-care",
  },
  {
    src: supplierConfectionery,
    alt: "Confectionery & Sweets",
    title: "Confectionery & Sweets",
    slug: "confectionery-sweets",
  },
  {
    src: supplierBiscuits,
    alt: "Biscuits, Cakes & Bars",
    title: "Biscuits, Cakes & Bars",
    slug: "biscuits-cakes-bars",
  },
  {
    src: supplierCrisps,
    alt: "Crisps, Nuts & Snacks",
    title: "Crisps, Nuts & Snacks",
    slug: "crisps-nuts-snacks",
  },
  { src: supplierGrocery, alt: "Grocery", title: "Grocery", slug: "grocery" },
  { src: supplierFrozen, alt: "Frozen", title: "Frozen", slug: "frozen" },
  {
    src: supplierPersonalCare,
    alt: "Personal Care & Wellbeing",
    title: "Personal Care & Wellbeing",
    slug: "personal-care-wellbeing",
  },
  {
    src: supplierHousehold,
    alt: "Household & Cleaning",
    title: "Household & Cleaning",
    slug: "household-cleaning",
  },
  {
    src: supplierPetCare,
    alt: "Pet Care",
    title: "Pet Care",
    slug: "pet-care",
  },
  {
    src: supplierFreeFrom,
    alt: "Free From & Special Diet",
    title: "Free From & Special Diet",
    slug: "free-from-special-diet",
  },
  {
    src: supplierSeasonal,
    alt: "Seasonal Ranges for Every Occasion",
    title: "Seasonal",
    slug: "seasonal",
  },
];

const trustedBrandLogos = [
  { src: ferreroLogo, alt: "Ferrero" },
  { src: kinderLogo, alt: "Kinder" },
  { src: lindtLogo, alt: "Lindt" },
  { src: marsLogo, alt: "Mars" },
  { src: nestleLogo, alt: "Nestlé" },
  { src: cocaColaLogo, alt: "Coca-Cola" },
  { src: hariboLogo, alt: "Haribo" },
  { src: kelloggsLogo, alt: "Kellogg's" },
  { src: kitKatLogo, alt: "Kit Kat" },
  { src: mondelezLogo, alt: "Mondelez" },
  { src: pepsicoLogo, alt: "PepsiCo" },
  { src: redBullLogo, alt: "Red Bull" },
  { src: starbucksLogo, alt: "Starbucks" },
  { src: unileverLogo, alt: "Unilever" },
  { src: weetabixLogo, alt: "Weetabix" },
  { src: evianLogo, alt: "Evian" },
  { src: monsterLogo, alt: "Monster Energy" },
  { src: swizzelsLogo, alt: "Swizzels" },
  { src: perfettiLogo, alt: "Perfetti Van Melle" },
  { src: agBarrLogo, alt: "AG Barr" },
];

const HOME_HERO_SLIDES = [
  { src: heroSlide01, alt: "Drinks" },
  { src: heroSlide02, alt: "Baby care" },
  { src: heroSlide03, alt: "Confectionery & Sweets" },
  { src: heroSlide04, alt: "Biscuits, Cakes & Bars" },
  { src: heroSlide05, alt: "Crisps, Nuts & Snacks" },
  { src: heroSlide06, alt: "Grocery" },
  { src: heroSlide07, alt: "Frozen" },
  { src: heroSlide08, alt: "Personal Care & Wellbeing" },
  { src: heroSlide09, alt: "Household & Cleaning" },
  { src: heroSlide10, alt: "Pet Care" },
  { src: heroSlide11, alt: "Free From & Special Diet" },
  {
    src: heroSlide12,
    alt: "Seasonal",
  },
];

const HERO_AUTOPLAY_MS = 2000;

const aboutUsParagraphs = [
  "UK TO MARS LTD is a UK-based wholesaler and exporter of British and European FMCG products, supplying trusted brands at competitive wholesale prices to customers worldwide. From food and drink to confectionery, household, personal care and baby care, we offer reliable supply, flexible ordering — from cases to full containers — and full export support.",
];

const brandSx = {
  navy: NAV.navy,
  blue: "#1e5a9e",
  blueLight: "#e8f2fa",
  blueBorder: "#b8d4eb",
  ink: "#1a1d21",
  muted: "#5c6370",
  whatsapp: "#25D366",
};

const howItWorksHeaderFont = {
  label: { xs: "0.8rem", sm: "0.875rem", md: "0.95rem" },
  title: { xs: "1.65rem", sm: "1.9rem", md: "2.25rem", lg: "2.5rem" },
  subtitle: { xs: "1rem", sm: "1.1rem", md: "1.2rem", lg: "1.25rem" },
};

const howItWorksSteps = [
  {
    num: 1,
    title: "Browse Products",
    description:
      "Explore our wide range of quality wholesale products across multiple categories.",
    image: howItWorksBrowseImg,
    imageAlt: "Browse Products",
  },
  {
    num: 2,
    title: "Add to Quote",
    description:
      "Select your required products and quantities with ease using our simple basket system.",
    image: howItWorksBasketImg,
    imageAlt: "Add to Quote",
  },
  {
    num: 3,
    title: "Submit Inquiry",
    description:
      "Send your basket as an inquiry and receive a tailored quotation from our team.",
    image: howItWorksInquiryImg,
    imageAlt: "Submit Inquiry",
  },
  {
    num: 4,
    title: "Confirmation & Dispatch",
    description:
      "Once confirmed, we handle packaging, dispatch and reliable delivery.",
    image: howItWorksDispatchImg,
    imageAlt: "Confirmation & Dispatch",
  },
];

const ourServicesOfferings = [
  {
    title: "Consolidation & Bulk Loading",
    description:
      "We consolidate products from multiple suppliers, optimise loading and maximize space to reduce costs.",
    to: "/ourservices",
    image: serviceConsolidationImg,
    imageAlt: "Consolidation & Bulk Loading",
  },
  {
    title: "Flexible Transportation Solutions",
    description:
      "Sea, air or road — we arrange the most reliable and cost-effective transport for you.",
    to: "/ourservices",
    image: serviceTransportImg,
    imageAlt: "Flexible Transportation Solutions",
  },
  {
    title: "Labelling & Packaging Services",
    description:
      "Custom labelling, Arabic translation and packaging solutions to meet local market requirements.",
    to: "/ourservices",
    image: serviceLabellingImg,
    imageAlt: "Labelling & Packaging Services",
  },
  {
    title: "Export Documentation & Compliance",
    description:
      "We manage all export documents and ensure full compliance with international regulations.",
    to: "/ourservices",
    image: serviceExportDocsImg,
    imageAlt: "Export Documentation & Compliance",
  },
  {
    title: "End to End Support",
    description:
      "Dedicated support from inquiry to delivery, ensuring a smooth and hassle-free experience.",
    to: "/AboutUs",
    image: serviceEndToEndImg,
    imageAlt: "End to End Support",
  },
];

const partnerFeatures = [
  { label: "Reliable Supply", Icon: ShieldOutlinedIcon },
  { label: "Competitive Pricing", Icon: SellOutlinedIcon },
  { label: "On-Time Delivery", Icon: ScheduleOutlinedIcon },
  { label: "Long Term Partnerships", Icon: GroupsOutlinedIcon },
];

function HomeSectionHeader({ label, title, subtitle, titleId, titleSx }) {
  return (
    <Box sx={{ mb: { xs: 3, md: 4 } }}>
      {label ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            mb: 2,
          }}
        >
          <Box sx={{ width: 48, height: 2, bgcolor: brandSx.blue }} />
          <Typography
            component="span"
            sx={{
              color: brandSx.blue,
              fontWeight: 700,
              letterSpacing: "0.16em",
              fontSize: howItWorksHeaderFont.label,
              textTransform: "uppercase",
              lineHeight: 1.2,
            }}
          >
            {label}
          </Typography>
          <Box sx={{ width: 48, height: 2, bgcolor: brandSx.blue }} />
        </Box>
      ) : null}
      <Typography
        id={titleId}
        variant="h4"
        component="h2"
        sx={{
          textAlign: "center",
          fontWeight: 800,
          color: brandSx.navy,
          fontSize: howItWorksHeaderFont.title,
          lineHeight: { xs: 1.25, md: 1.2 },
          ...sectionTitleSpacingSx,
          mb: { xs: 1.5, md: 2 },
          px: { xs: 1, sm: 0 },
          ...titleSx,
        }}
      >
        {title}
      </Typography>
      {subtitle ? (
        <Typography
          variant="body1"
          component="p"
          sx={{
            textAlign: "center",
            color: brandSx.muted,
            maxWidth: 780,
            mx: "auto",
            fontSize: howItWorksHeaderFont.subtitle,
            lineHeight: { xs: 1.65, md: 1.7 },
            fontWeight: 400,
            px: { xs: 1, sm: 0 },
          }}
        >
          {subtitle}
        </Typography>
      ) : null}
      <Box
        sx={{
          width: 44,
          height: 4,
          bgcolor: brandSx.blue,
          borderRadius: 1,
          mx: "auto",
          mt: 2.5,
        }}
      />
    </Box>
  );
}

function ServiceOfferingCard({ service }) {
  const { image, imageAlt, title, description, to } = service;
  return (
    <Card
      elevation={0}
      sx={{
        height: "100%",
        minHeight: { xs: 280, md: 300 },
        borderRadius: 3,
        bgcolor: "#fff",
        border: "1px solid #e8ecf0",
        boxShadow: "0 2px 14px rgba(15, 40, 71, 0.05)",
        transition: "transform 0.25s ease, box-shadow 0.25s ease",
        display: "flex",
        flexDirection: "column",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 12px 32px rgba(15, 40, 71, 0.1)",
        },
      }}
    >
      <CardContent
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          px: { xs: 2, md: 2.25 },
          py: { xs: 3, md: 3.5 },
        }}
      >
        <Box
          sx={{
            width: "100%",
            minHeight: { xs: 100, md: 110 },
            mx: "auto",
            mb: 2.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            px: 0.5,
          }}
        >
          <Box
            component="img"
            src={image}
            alt={imageAlt}
            sx={{
              display: "block",
              width: "100%",
              maxWidth: { xs: 120, md: 140 },
              height: "auto",
              objectFit: "contain",
            }}
          />
        </Box>
        <Typography
          component={to ? Link : "p"}
          to={to}
          variant="subtitle1"
          sx={{
            fontWeight: 700,
            color: brandSx.navy,
            fontSize: { xs: "0.9375rem", md: "1rem" },
            lineHeight: 1.4,
            mb: 1.25,
            textDecoration: "none",
            display: "block",
            minHeight: { md: "2.8em" },
            "&:hover": to ? { color: brandSx.blue } : undefined,
          }}
        >
          {title}
        </Typography>
        <Box
          sx={{
            width: 36,
            height: 3,
            bgcolor: brandSx.blue,
            borderRadius: 1,
            mx: "auto",
            mb: 1.75,
          }}
        />
        <Typography
          variant="body2"
          sx={{
            color: brandSx.muted,
            lineHeight: 1.7,
            fontSize: { xs: "0.8125rem", md: "0.875rem" },
            maxWidth: 220,
            mx: "auto",
            flex: 1,
          }}
        >
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
}

const trustItems = [
  {
    title: "Trusted UK Wholesaler",
    subtitle: "Reliable & Professional",
    Icon: GppGoodIcon,
    iconHighlight: true,
  },
  {
    title: "Worldwide Export Support",
    subtitle: "Shipping to 100+ Countries",
    Icon: PublicOutlinedIcon,
  },
  {
    title: "Reliable Supply & Delivery",
    subtitle: "On Time, Every Time",
    Icon: LocalShippingIcon,
  },
  {
    title: "Long Term Partnerships",
    subtitle: "Built on Trust & Quality",
    Icon: HandshakeOutlinedIcon,
  },
];

function HowItWorksStepCard({ step }) {
  return (
    <Card
      elevation={0}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: 3,
        bgcolor: "#fff",
        border: `1px solid ${brandSx.blueBorder}`,
        boxShadow: "0 4px 18px rgba(15, 40, 71, 0.08)",
        transition: "transform 0.25s ease, box-shadow 0.25s ease",
        overflow: "visible",
        position: "relative",
        mt: 2,
        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: "0 14px 32px rgba(15, 40, 71, 0.14)",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: -16,
          left: "50%",
          transform: "translateX(-50%)",
          width: 36,
          height: 36,
          borderRadius: "50%",
          bgcolor: brandSx.blue,
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 700,
          fontSize: "1rem",
          zIndex: 2,
          border: "3px solid #fff",
          boxShadow: "0 4px 12px rgba(30, 90, 158, 0.35)",
        }}
      >
        {step.num}
      </Box>

      <CardContent
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          pt: { xs: 3, md: 4 },
          pb: { xs: 2, md: 3 },
          px: { xs: 1.25, sm: 2, md: 2.5 },
        }}
      >
        <Box
          sx={{
            width: "100%",
            minHeight: { xs: 96, md: 140 },
            mb: { xs: 1.5, md: 2 },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: 0.5,
          }}
        >
          <Box
            component="img"
            src={step.image}
            alt={step.imageAlt}
            sx={{
              display: "block",
              width: "100%",
              maxWidth: { xs: 110, sm: 140, md: 200 },
              height: "auto",
              objectFit: "contain",
            }}
          />
        </Box>

        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 700,
            color: brandSx.navy,
            mb: { xs: 0.75, md: 1.25 },
            fontSize: { xs: "0.875rem", sm: "0.95rem", md: "1.05rem" },
            lineHeight: 1.35,
          }}
        >
          {step.title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: brandSx.muted,
            lineHeight: 1.55,
            fontSize: { xs: "0.72rem", sm: "0.78rem", md: "0.875rem" },
            maxWidth: { xs: "100%", md: 260 },
            mx: "auto",
          }}
        >
          {step.description}
        </Typography>
      </CardContent>
    </Card>
  );
}

const homeSectionSpace = {
  /** Vertical space between major home page blocks */
  block: { xs: 6, md: 10 },
  /** Vertical space between subsections inside the about area */
  inner: { xs: 4, md: 6 },
};

const homePageContentSx = {
  maxWidth: HOME_PAGE_MAX_WIDTH,
  mx: "auto",
  width: "100%",
  boxSizing: "border-box",
};

const pageSx = {
  fontFamily: FONT_FAMILY,
  textAlign: "center",
  bgcolor: "#fff",
  color: "#333",
  minHeight: "100vh",
  width: "100%",
  px: 0,
  pb: 0,
  pt: { xs: 4, md: 0 },
  m: 0,
  overflowX: "hidden",
};

const heroWrapSx = {
  width: "100%",
  m: 0,
  p: 0,
  lineHeight: 0,
  overflow: "hidden",
  position: "relative",
  bgcolor: "#e8ecf0",
};

function TrustedBrandLogo({ brand, decorative = false }) {
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        height: { xs: 52, md: 60 },
        px: { xs: 1, md: 1.5 },
      }}
    >
      <Box
        component="img"
        src={brand.src}
        alt={decorative ? "" : brand.alt}
        aria-hidden={decorative ? true : undefined}
        sx={{
          display: "block",
          height: { xs: 36, sm: 40, md: 44 },
          width: "auto",
          maxWidth: { xs: 120, md: 160 },
          objectFit: "contain",
        }}
      />
    </Box>
  );
}

function HomeTrustedBrandsStrip() {
  const marqueeLogos = [...trustedBrandLogos, ...trustedBrandLogos];

  return (
    <Box
      component="div"
      aria-labelledby="home-trusted-brands-heading"
      sx={{
        mb: homeSectionSpace.inner,
        width: "100%",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          ...homePageContentSx,
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <HomeSectionHeader
          titleId="home-trusted-brands-heading"
          label="Trusted brands"
          title="Trusted Global & UK Brands"
          subtitle="Wholesale supply of leading FMCG brands across food, drinks, household, personal care, baby care, and beyond."
        />
      </Box>

      <Box
        sx={{
          width: "100%",
          background: TRUSTED_BRANDS_BG,
          py: { xs: 2, md: 2.5 },
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "max-content",
            gap: { xs: 3, sm: 4, md: 5 },
            px: { xs: 2, md: 3 },
            animation: "trustedBrandsScroll 55s linear infinite",
            "@keyframes trustedBrandsScroll": {
              "0%": { transform: "translateX(0)" },
              "100%": { transform: "translateX(-50%)" },
            },
            "@media (prefers-reduced-motion: reduce)": {
              display: "none",
            },
            "&:hover": {
              animationPlayState: "paused",
            },
          }}
        >
          {marqueeLogos.map((brand, index) => (
            <TrustedBrandLogo
              key={`${brand.alt}-${index}`}
              brand={brand}
              decorative={index >= trustedBrandLogos.length}
            />
          ))}
        </Box>
        <Box
          sx={{
            display: "none",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: { xs: 2, md: 3 },
            px: { xs: 2, md: 3 },
            py: 0.5,
            ...homePageContentSx,
            "@media (prefers-reduced-motion: reduce)": {
              display: "flex",
            },
          }}
        >
          {trustedBrandLogos.map((brand) => (
            <TrustedBrandLogo key={brand.alt} brand={brand} />
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function HomeSupplierCategoriesSection() {
  return (
    <Box
      component="section"
      aria-labelledby="home-supplier-categories-heading"
      sx={{
        width: "100%",
        bgcolor: "#fff",
        px: { xs: 2, sm: 3, md: 4 },
        pt: homeSectionSpace.inner,
        pb: homeSectionSpace.inner,
      }}
    >
      <Box sx={homePageContentSx}>
        <HomeSectionHeader
          titleId="home-supplier-categories-heading"
          label="categories"
          title="Everything You Need. One UK Supplier"
          subtitle="Explore every FMCG category we supply, ready by case, pallet, or container for wholesale and export."
        />

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(2, minmax(0, 1fr))",
              sm: "repeat(3, minmax(0, 1fr))",
              md: "repeat(4, minmax(0, 1fr))",
              lg: "repeat(6, minmax(0, 1fr))",
            },
            gap: { xs: 1.25, sm: 1.5, md: 2 },
          }}
        >
          {supplierCategories.map((category) => (
            <Box
              key={category.title}
              component={Link}
              to={
                category.to ??
                (category.slug
                  ? getCategoryProductsPath(category.slug)
                  : "/products")
              }
              sx={{
                display: "block",
                borderRadius: 2,
                overflow: "hidden",
                textDecoration: "none",
                color: "inherit",
                border: `1px solid ${brandSx.blueBorder}`,
                boxShadow: "0 2px 10px rgba(15, 40, 71, 0.06)",
                transition:
                  "transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 12px 28px rgba(15, 40, 71, 0.12)",
                  borderColor: brandSx.blue,
                },
                "&:focus-visible": {
                  outline: `2px solid ${brandSx.blue}`,
                  outlineOffset: 2,
                },
              }}
            >
              <Box
                component="img"
                src={category.src}
                alt={category.alt}
                sx={{
                  display: "block",
                  width: "100%",
                  height: "auto",
                  verticalAlign: "middle",
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function HomePromotionCard({ offer }) {
  const imageUrl = toPromotionAssetUrl(offer?.image_url || offer?.image);
  const pdfUrl = toPromotionAssetUrl(offer?.pdf_file_url || offer?.pdf_url);
  const href = pdfUrl || "/Promotions";
  const isExternal = Boolean(pdfUrl);

  return (
    <Card
      elevation={0}
      component={isExternal ? "a" : Link}
      href={isExternal ? href : undefined}
      to={isExternal ? undefined : href}
      target={isExternal ? "_blank" : undefined}
      rel={isExternal ? "noreferrer" : undefined}
      sx={{
        border: `2px solid ${brandSx.blue}`,
        borderRadius: 2.5,
        overflow: "hidden",
        textDecoration: "none",
        bgcolor: "#fff",
        p: 0.75,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 4px 16px rgba(15, 40, 71, 0.08)",
        transition: "transform 0.22s ease, box-shadow 0.22s ease",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 14px 32px rgba(15, 40, 71, 0.14)",
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
          borderRadius: 1.5,
          overflow: "hidden",
          aspectRatio: PROMOTION_IMAGE_ASPECT_RATIO,
          bgcolor: "#f8fafc",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
        }}
      >
        {imageUrl ? (
          <Box
            component="img"
            src={imageUrl}
            alt=""
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              objectPosition: "center",
              display: "block",
            }}
          />
        ) : (
          <LocalOfferOutlinedIcon sx={{ fontSize: 48, color: brandSx.muted }} />
        )}
      </Box>
    </Card>
  );
}

function HomePromotionsSection() {
  const [offers, setOffers] = useState([]);
  const [totalOfferCount, setTotalOfferCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadPromotions = async () => {
      try {
        const response = await fetch(PROMOTIONS_API_URL);
        if (!response.ok) throw new Error("Failed to fetch promotions");
        const payload = await response.json();
        const data = Array.isArray(payload?.data) ? payload.data : [];
        if (isMounted) {
          setTotalOfferCount(data.length);
          setOffers(data.slice(0, HOME_PROMOTIONS_LIMIT));
        }
      } catch {
        if (isMounted) {
          setOffers([]);
          setTotalOfferCount(0);
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadPromotions();
    return () => {
      isMounted = false;
    };
  }, []);

  const placeholders = Array.from(
    { length: HOME_PROMOTIONS_LIMIT },
    (_, i) => ({
      id: `placeholder-${i}`,
    }),
  );

  return (
    <Box
      component="section"
      aria-labelledby="home-promotions-heading"
      sx={{
        width: "100%",
        bgcolor: "#fff",
        px: { xs: 2, sm: 3, md: 4 },
        pt: homeSectionSpace.inner,
        pb: homeSectionSpace.inner,
      }}
    >
      <Box sx={homePageContentSx}>
        <HomeSectionHeader
          titleId="home-promotions-heading"
          title="Latest Offers & Wholesale Opportunities"
          subtitle="Discover current wholesale deals and export-ready offers from UK TO MARS LTD."
        />

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(3, minmax(0, 1fr))",
            },
            gap: { xs: 2, md: 3 },
            mb: { xs: 3, md: 3.5 },
          }}
        >
          {loading
            ? placeholders.map((item) => (
                <Box
                  key={item.id}
                  sx={{
                    borderRadius: 2.5,
                    aspectRatio: PROMOTION_IMAGE_ASPECT_RATIO,
                    bgcolor: brandSx.blueLight,
                    border: `1px solid ${brandSx.blueBorder}`,
                    animation: "pulse 1.5s ease-in-out infinite",
                    "@keyframes pulse": {
                      "0%, 100%": { opacity: 1 },
                      "50%": { opacity: 0.55 },
                    },
                  }}
                />
              ))
            : offers.length > 0
              ? offers.map((offer) => (
                  <HomePromotionCard
                    key={offer.id ?? offer.title}
                    offer={offer}
                  />
                ))
              : placeholders.map((item) => (
                  <HomePromotionCard key={item.id} offer={{}} />
                ))}
        </Box>

        {!loading && totalOfferCount > HOME_PROMOTIONS_LIMIT ? (
          <Box sx={{ textAlign: "center" }}>
            <Box
              component={Link}
              to="/Promotions"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.75,
                px: 3,
                py: 1.25,
                borderRadius: 999,
                bgcolor: brandSx.navy,
                color: "#fff",
                fontWeight: 700,
                fontSize: "0.9375rem",
                textDecoration: "none",
                transition: "background-color 0.2s ease, transform 0.2s ease",
                "&:hover": {
                  bgcolor: brandSx.blue,
                  transform: "translateY(-1px)",
                },
              }}
            >
              View all offers
              <ChevronRightIcon sx={{ fontSize: 20 }} />
            </Box>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}

function HomeAboutSection() {
  return (
    <Box
      component="div"
      sx={{
        width: "100%",
        bgcolor: "#fff",
        overflow: "hidden",
        fontFamily: FONT_FAMILY,
        pt: homeSectionSpace.block,
      }}
    >
      <HomeTrustedBrandsStrip />
      <HomeSupplierCategoriesSection />
      <HomePromotionsSection />

      <Box
        component="section"
        aria-labelledby="home-about-heading"
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
          pt: homeSectionSpace.inner,
          pb: homeSectionSpace.block,
          textAlign: "left",
        }}
      >
        <Box
          sx={{
            ...homePageContentSx,
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            columnGap: { md: 4, lg: 5 },
            rowGap: { xs: 3, md: 0 },
            alignItems: "start",
          }}
        >
          <Box
            sx={{ minWidth: 0, pr: { md: 1, lg: 2 }, order: { xs: 2, md: 1 } }}
          >
            <Typography
              id="home-about-heading"
              component="h2"
              sx={{
                fontWeight: 700,
                fontSize: { xs: "1.75rem", md: "2rem", lg: "2.125rem" },
                color: "#000",
                letterSpacing: "-0.01em",
                lineHeight: 1.2,
                textAlign: "left",
                mb: { xs: 2, md: 2.5 },
              }}
            >
              About us
            </Typography>
            {aboutUsParagraphs.map((paragraph, index) => (
              <Typography
                key={paragraph.slice(0, 24)}
                component="p"
                sx={{
                  color: brandSx.ink,
                  fontSize: { xs: "0.9375rem", md: "1rem" },
                  fontWeight: 400,
                  lineHeight: 1.8,
                  textAlign: "left",
                  m: 0,
                  mb:
                    index < aboutUsParagraphs.length - 1
                      ? { xs: 1.75, md: 2 }
                      : 0,
                }}
              >
                {paragraph}
              </Typography>
            ))}
          </Box>

          <Box sx={{ minWidth: 0, width: "100%", order: { xs: 1, md: 2 } }}>
            <Box
              component="img"
              src={aboutWarehouseImg}
              alt="UK TO MARS LTD warehouse — 15k+ SKUs, UK and EU sourcing, FCA and Incoterms 2020, global buyer network"
              sx={{
                display: "block",
                width: "100%",
                maxWidth: "100%",
                height: "auto",
                mx: "auto",
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

function HomeHeroSlider() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const slideCount = HOME_HERO_SLIDES.length;

  const goTo = useCallback(
    (index) => {
      setActiveIndex(((index % slideCount) + slideCount) % slideCount);
    },
    [slideCount],
  );

  useEffect(() => {
    if (paused || slideCount <= 1) return undefined;
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % slideCount);
    }, HERO_AUTOPLAY_MS);
    return () => clearInterval(timer);
  }, [paused, slideCount]);

  return (
    <Box
      component="section"
      aria-label="Product category highlights"
      sx={{
        ...heroWrapSx,
        aspectRatio: "1900 / 809",
      }}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocus={() => setPaused(true)}
      onBlur={() => setPaused(false)}
    >
      <Box
        sx={{
          display: "flex",
          height: "100%",
          width: `${slideCount * 100}%`,
          transform: `translate3d(-${(activeIndex * 100) / slideCount}%, 0, 0)`,
          transition: "transform 0.65s cubic-bezier(0.4, 0, 0.2, 1)",
          willChange: "transform",
        }}
      >
        {HOME_HERO_SLIDES.map((slide, index) => (
          <Box
            key={slide.alt}
            component="img"
            src={slide.src}
            alt={slide.alt}
            aria-hidden={index !== activeIndex}
            sx={{
              display: "block",
              flex: `0 0 ${100 / slideCount}%`,
              width: `${100 / slideCount}%`,
              height: "100%",
              objectFit: "cover",
              objectPosition: "center center",
              userSelect: "none",
              pointerEvents: "none",
            }}
          />
        ))}
      </Box>

      {slideCount > 1 && (
        <Box
          sx={{
            position: "absolute",
            bottom: { xs: 12, md: 18 },
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            gap: 1,
            px: 1.5,
            py: 0.75,
            borderRadius: 999,
            bgcolor: "rgba(15, 40, 71, 0.35)",
          }}
        >
          {HOME_HERO_SLIDES.map((slide, index) => (
            <Box
              key={`dot-${slide.alt}`}
              component="button"
              type="button"
              aria-label={`Go to ${slide.alt}`}
              aria-current={index === activeIndex ? "true" : undefined}
              onClick={() => goTo(index)}
              sx={{
                width: index === activeIndex ? 22 : 8,
                height: 8,
                p: 0,
                border: "none",
                borderRadius: 999,
                cursor: "pointer",
                bgcolor:
                  index === activeIndex ? "#fff" : "rgba(255,255,255,0.55)",
                transition: "width 0.25s ease, background-color 0.25s ease",
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}

const Home = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Box component="div" sx={pageSx}>
      <HomeHeroSlider />

      <Box component="main">
        <HomeAboutSection />

        <Box sx={{ width: "100%", m: 0, p: 0 }}>
          <Box
            sx={{
              width: "100%",
              px: { xs: 2, sm: 3, md: 4 },
              pt: homeSectionSpace.block,
              pb: homeSectionSpace.inner,
              bgcolor: "#fff",
            }}
          >
            <Box sx={homePageContentSx}>
              <HomeSectionHeader
                label="How it works"
                title="Simple. Efficient. Wholesale Made Easy."
                subtitle="From browsing to delivery – we make wholesale ordering simple for local and international customers."
              />

              <Box
                sx={{
                  display: { xs: "grid", lg: "flex" },
                  gridTemplateColumns: {
                    xs: "repeat(2, minmax(0, 1fr))",
                    sm: "repeat(2, minmax(0, 1fr))",
                  },
                  alignItems: "stretch",
                  flexDirection: { lg: "row" },
                  gap: { xs: 2, sm: 2.5, lg: 0.5 },
                  pt: 2,
                }}
              >
                {howItWorksSteps.map((step, index) => (
                  <React.Fragment key={step.num}>
                    <Box
                      sx={{
                        flex: 1,
                        minWidth: 0,
                        display: "flex",
                        alignItems: "stretch",
                      }}
                    >
                      <HowItWorksStepCard step={step} />
                    </Box>
                    {index < howItWorksSteps.length - 1 && (
                      <Box
                        sx={{
                          display: { xs: "none", lg: "flex" },
                          alignItems: "center",
                          alignSelf: "center",
                          px: 0.25,
                          color: brandSx.blue,
                          flexShrink: 0,
                        }}
                      >
                        <ChevronRightIcon
                          sx={{ fontSize: 36, opacity: 0.85 }}
                        />
                      </Box>
                    )}
                  </React.Fragment>
                ))}
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              width: "100%",
              px: { xs: 2, sm: 3, md: 4 },
              pt: homeSectionSpace.inner,
              pb: homeSectionSpace.inner,
              // bgcolor: brandSx.blueLight,
              borderTop: `1px solid ${brandSx.blueBorder}`,
              borderBottom: `1px solid ${brandSx.blueBorder}`,
            }}
          >
            <Box
              sx={{
                ...homePageContentSx,
                display: "flex",
                flexDirection: { xs: "column", lg: "row" },
                alignItems: { xs: "stretch", lg: "center" },
                gap: { xs: 3, lg: 4 },
                p: { xs: 2, md: 3 },
                borderRadius: 2,
                border: `1px solid ${brandSx.blueBorder}`,
                // bgcolor: "#fff",
                bgcolor: brandSx.blueLight,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  alignItems: "flex-start",
                  flex: { lg: "1 1 45%" },
                }}
              >
                <Box
                  sx={{
                    width: { xs: 56, md: 64 },
                    height: { xs: 56, md: 64 },
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    component="img"
                    src={specificProductImg}
                    alt="Looking for a specific product"
                    sx={{
                      display: "block",
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Box>
                <Box sx={{ textAlign: "left" }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 700, color: brandSx.navy, mb: 0.75 }}
                  >
                    Looking for a specific product?
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: brandSx.muted, lineHeight: 1.65 }}
                  >
                    We can source products beyond our listed range through our
                    trusted supplier network.
                  </Typography>
                </Box>
              </Box>

              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  display: { xs: "none", lg: "block" },
                  borderColor: brandSx.blueBorder,
                }}
              />
              <Divider
                sx={{
                  display: { xs: "block", lg: "none" },
                  borderColor: brandSx.blueBorder,
                }}
              />

              <Grid
                container
                spacing={{ xs: 1, sm: 2 }}
                sx={{ flex: { lg: "1 1 55%" }, alignItems: "center" }}
              >
                <Grid item xs={4} sm={4}>
                  <Box sx={{ textAlign: "center" }}>
                    <EmailOutlinedIcon
                      sx={{
                        color: brandSx.blue,
                        fontSize: { xs: 24, sm: 32 },
                        mb: 0.5,
                      }}
                    />
                    <Typography
                      variant="caption"
                      sx={{
                        display: "block",
                        color: brandSx.muted,
                        fontWeight: 600,
                        fontSize: { xs: "0.65rem", sm: "0.75rem" },
                        lineHeight: 1.2,
                      }}
                    >
                      Email Us
                    </Typography>
                    <Typography
                      component="a"
                      href="mailto:sales@uktomars.co.uk"
                      variant="body2"
                      sx={{
                        color: brandSx.blue,
                        fontWeight: 600,
                        textDecoration: "none",
                        fontSize: { xs: "0.62rem", sm: "0.875rem" },
                        lineHeight: 1.35,
                        wordBreak: "break-word",
                        "&:hover": { textDecoration: "underline" },
                      }}
                    >
                      sales@uktomars.co.uk
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Box sx={{ textAlign: "center" }}>
                    <Box
                      component="img"
                      src="https://cdn-icons-png.flaticon.com/512/220/220236.png"
                      alt=""
                      sx={{
                        width: { xs: 24, sm: 32 },
                        height: { xs: 24, sm: 32 },
                        mb: 0.5,
                      }}
                    />
                    <Typography
                      variant="caption"
                      sx={{
                        display: "block",
                        color: brandSx.muted,
                        fontWeight: 600,
                        fontSize: { xs: "0.65rem", sm: "0.75rem" },
                        lineHeight: 1.2,
                      }}
                    >
                      WhatsApp
                    </Typography>
                    <Typography
                      component="a"
                      href="https://wa.me/447564627910"
                      target="_blank"
                      rel="noopener noreferrer"
                      variant="body2"
                      sx={{
                        color: brandSx.whatsapp,
                        fontWeight: 600,
                        textDecoration: "none",
                        fontSize: { xs: "0.62rem", sm: "0.875rem" },
                        lineHeight: 1.35,
                        wordBreak: "break-word",
                        "&:hover": { textDecoration: "underline" },
                      }}
                    >
                      +44 7564 627910
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Box sx={{ textAlign: "center" }}>
                    <PhoneOutlinedIcon
                      sx={{
                        color: brandSx.blue,
                        fontSize: { xs: 24, sm: 32 },
                        mb: 0.5,
                      }}
                    />
                    <Typography
                      variant="caption"
                      sx={{
                        display: "block",
                        color: brandSx.muted,
                        fontWeight: 600,
                        fontSize: { xs: "0.65rem", sm: "0.75rem" },
                        lineHeight: 1.2,
                      }}
                    >
                      Telephone
                    </Typography>
                    <Typography
                      component="a"
                      href="tel:+441280733473"
                      variant="body2"
                      sx={{
                        color: brandSx.blue,
                        fontWeight: 600,
                        textDecoration: "none",
                        fontSize: { xs: "0.62rem", sm: "0.875rem" },
                        lineHeight: 1.35,
                        wordBreak: "break-word",
                        "&:hover": { textDecoration: "underline" },
                      }}
                    >
                      +44 1280 733473
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>

          <Box
            sx={{
              width: "100%",
              bgcolor: brandSx.navy,
              // bgcolor: HOME_PAGE_GRADIENT,
              py: homeSectionSpace.inner,
              px: { xs: 2, sm: 3, md: 4 },
            }}
          >
            <Grid container spacing={{ xs: 2, sm: 3 }} sx={homePageContentSx}>
              {trustItems.map(({ title, subtitle, Icon, iconHighlight }) => (
                <Grid item xs={6} sm={6} md={3} key={title}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: { xs: 1, sm: 1.5 },
                      justifyContent: { xs: "center", md: "flex-start" },
                      textAlign: { xs: "center", md: "left" },
                      flexDirection: { xs: "column", sm: "row" },
                    }}
                  >
                    <Box
                      sx={{
                        width: { xs: 44, sm: 52 },
                        height: { xs: 44, sm: 52 },
                        borderRadius: iconHighlight ? "50%" : 1.5,
                        bgcolor: iconHighlight
                          ? "rgba(126, 184, 247, 0.2)"
                          : "rgba(255,255,255,0.12)",
                        border: iconHighlight
                          ? "2px solid rgba(126, 184, 247, 0.45)"
                          : "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <Icon
                        sx={{
                          color: "#7eb8f7",
                          fontSize: {
                            xs: iconHighlight ? 26 : 24,
                            sm: iconHighlight ? 32 : 28,
                          },
                        }}
                      />
                    </Box>
                    <Box>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color: "#fff",
                          fontWeight: 700,
                          lineHeight: 1.3,
                          fontSize: { xs: "0.72rem", sm: "0.875rem" },
                        }}
                      >
                        {title}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: "rgba(255,255,255,0.75)",
                          fontSize: { xs: "0.62rem", sm: "0.75rem" },
                          lineHeight: 1.35,
                          display: "block",
                        }}
                      >
                        {subtitle}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>

        {/* our services */}
        <Box
          sx={{
            width: "100%",
            px: { xs: 2, sm: 3, md: 4 },
            pt: homeSectionSpace.block,
            pb: homeSectionSpace.block,
            bgcolor: "#fff",
          }}
        >
          <Box sx={homePageContentSx}>
            <HomeSectionHeader
              label="Our Services"
              title="Global FMCG Solutions, End to End."
              subtitle="We handle everything so you can focus on growing your business."
            />

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "repeat(2, 1fr)",
                  md: "repeat(3, 1fr)",
                  lg: "repeat(5, 1fr)",
                },
                gap: { xs: 2, lg: 2 },
                mb: { xs: 4, md: 5 },
                alignItems: "stretch",
              }}
            >
              {ourServicesOfferings.map((service) => (
                <ServiceOfferingCard key={service.title} service={service} />
              ))}
            </Box>

            <Box
              sx={{
                borderRadius: 3,
                bgcolor: "#eef5fb",
                border: `1px solid ${brandSx.blueBorder}`,
                p: { xs: 2.5, md: 4 },
                boxShadow: "0 4px 24px rgba(30, 90, 158, 0.07)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", lg: "row" },
                  alignItems: { xs: "stretch", lg: "center" },
                  gap: { xs: 3, lg: 0 },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    alignItems: "center",
                    flex: { lg: "1 1 40%" },
                    pr: { lg: 4 },
                    borderRight: {
                      lg: `1px solid ${brandSx.blueBorder}`,
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: 56, md: 64 },
                      height: { xs: 56, md: 64 },
                      borderRadius: "50%",
                      bgcolor: brandSx.navy,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      boxShadow: "0 4px 14px rgba(15, 40, 71, 0.2)",
                    }}
                  >
                    <PublicOutlinedIcon
                      sx={{ color: "#fff", fontSize: { xs: 32, md: 36 } }}
                    />
                  </Box>
                  <Box sx={{ textAlign: "left" }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        color: brandSx.navy,
                        fontSize: { xs: "1.05rem", md: "1.15rem" },
                        mb: 0.75,
                        lineHeight: 1.35,
                      }}
                    >
                      Your Trusted FMCG Export Partner
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: brandSx.muted,
                        lineHeight: 1.65,
                        fontSize: { xs: "0.875rem", md: "0.9375rem" },
                        maxWidth: 340,
                      }}
                    >
                      From sourcing to delivery, we provide reliable solutions
                      that keep your business moving forward.
                    </Typography>
                  </Box>
                </Box>

                <Divider
                  sx={{
                    display: { xs: "block", lg: "none" },
                    borderColor: brandSx.blueBorder,
                  }}
                />

                <Box
                  sx={{
                    flex: { lg: "1 1 60%" },
                    pl: { lg: 4 },
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "1fr 1fr",
                      lg: "repeat(4, 1fr)",
                    },
                    gap: { xs: 2, md: 2.5 },
                    alignItems: "center",
                  }}
                >
                  {partnerFeatures.map(({ label, Icon }) => (
                    <Box
                      key={label}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        gap: 1,
                      }}
                    >
                      <Box
                        sx={{
                          width: 44,
                          height: 44,
                          borderRadius: "50%",
                          bgcolor: "#fff",
                          border: `1px solid ${brandSx.blueBorder}`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Icon sx={{ color: brandSx.navy, fontSize: 24 }} />
                      </Box>
                      <Typography
                        sx={{
                          fontWeight: 600,
                          color: brandSx.blue,
                          fontSize: { xs: "0.8125rem", md: "0.875rem" },
                          lineHeight: 1.3,
                        }}
                      >
                        {label}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1.25,
                  flexWrap: "wrap",
                  mt: { xs: 3, md: 4 },
                  pt: { xs: 2.5, md: 3 },
                  borderTop: `1px solid ${brandSx.blueBorder}`,
                }}
              >
                <Box
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: "50%",
                    bgcolor: brandSx.navy,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <PhoneOutlinedIcon sx={{ color: "#fff", fontSize: 18 }} />
                </Box>
                <Typography
                  sx={{
                    color: brandSx.muted,
                    fontSize: { xs: "0.9375rem", md: "1rem" },
                  }}
                >
                  Need something specific?{" "}
                  <Typography
                    component={Link}
                    to="/ContactUs"
                    sx={{
                      color: brandSx.blue,
                      fontWeight: 700,
                      textDecoration: "none",
                      "&:hover": { textDecoration: "underline" },
                    }}
                  >
                    Contact Us
                  </Typography>
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <ContactChat />
    </Box>
  );
};

export default Home;
